// Pure display formatters for zone readouts. Kept out of the React components so
// the centidegree conversion and mode labelling can be unit-tested in isolation.

// darwin_core reports every temperature in centidegrees (2000 === 20.0 °C). Divide
// by 100 and show a single decimal. Returns null for missing/non-numeric input so
// callers can omit the readout rather than render "NaN°C" (a DHW zone, for
// example, reports no room temperature and no meaningful setpoint).
export function formatTemperature(centidegrees) {
  if (typeof centidegrees !== 'number' || !Number.isFinite(centidegrees)) {
    return null;
  }
  return `${(centidegrees / 100).toFixed(1)}°C`;
}

// Turns darwin_core's machine mode token into something readable without
// reinterpreting it: the human-friendly tokens (Auto/Manual/On/Off) pass through,
// and camelCase tokens (OverrideNext, …) gain spaces. Unknown/missing -> "Unknown"
// so a stale frame never renders an empty mode.
export function modeLabel(mode) {
  if (!mode || typeof mode !== 'string') {
    return 'Unknown';
  }
  return mode.replace(/([a-z])([A-Z])/g, '$1 $2');
}
